import { marketingHeroPhotos } from "./marketingPhotosConfig";

/**
 * Marketing hero background image(s).
 * Primary photo for backward-compatible single-image consumers.
 * Carousel uses the full list from marketingPhotosConfig.
 */
export const marketingHeroImage = {
  src: marketingHeroPhotos[0]?.src ?? null,
  alt: marketingHeroPhotos[0]?.alt ?? "Pro sports atmosphere",
};

export { marketingHeroPhotos };
